import { AuthService } from './auth.service';
import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var UserService = /** @class */ (function () {
    function UserService(http, auth) {
        this.http = http;
        this.auth = auth;
        this.editUser = new EventEmitter();
        this.originalUser = new EventEmitter();
        this._editing = false;
        this.URL = environment.baseServerURL + "/security";
    }
    Object.defineProperty(UserService.prototype, "editing", {
        get: function () {
            return this._editing;
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.buildURL = function (subPath) {
        return this.URL + "/user/" + subPath;
    };
    UserService.prototype.buildURLRole = function (subPath) {
        return this.URL + "/role/" + subPath;
    };
    UserService.prototype.getUserList = function () {
        return this.http.get(this.buildURL('company/' + this.auth.user.company.id), {
            withCredentials: true
        });
    };
    UserService.prototype.getUser = function (userId) {
        return this.http.get(this.buildURL(userId), {
            withCredentials: true
        });
    };
    UserService.prototype.getRoles = function () {
        return this.http.get(this.buildURLRole(''), {
            withCredentials: true
        });
    };
    UserService.prototype.addUser = function (user) {
        return this.http.post(this.buildURL(''), user, {
            withCredentials: true
        });
    };
    UserService.prototype.sendInvitation = function (email, token) {
        return this.http.post(this.buildURL('sendInvitation'), {
            email: email,
            token: token
        }, {
            withCredentials: true
        });
    };
    UserService.prototype.updateUser = function (user) {
        return this.http.put(this.buildURL(user.id), user, {
            withCredentials: true
        });
    };
    UserService.prototype.deleteUser = function (userId) {
        return this.http.delete(this.buildURL('delete/' + userId), {
            withCredentials: true
        });
    };
    UserService.prototype.updatePassword = function (userId, password) {
        return this.http.patch(this.buildURL('updatePassword/' + userId), {
            password: password
        }, {
            withCredentials: true
        });
    };
    // This method provides a boolean var, in order to tell the user-single.component if the edit button was pressed in the user list.
    UserService.prototype.updateDirectUser = function (updating) {
        this._editing = updating;
    };
    // This method is only used when an user for first time access to his account and assing the password
    UserService.prototype.activateUser = function (password, token) {
        return this.http.patch(this.buildURL('activateUser'), {
            password: password,
            token: token
        }, {
            withCredentials: true
        });
    };
    // resend invitation
    UserService.prototype.resendInvitation = function (user) {
        return this.http.post(this.buildURL('resendInvitation'), user, {
            withCredentials: true
        });
    };
    UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: UserService, providedIn: "root" });
    return UserService;
}());
export { UserService };
